import axios from "axios";
import Config from "../../../config";

// Dispara a sincronização dos usuários do Imoview com a tabela `usuarios` da
// LAIS (casa por email e grava config.imoview.codigoUsuario). Email/senha da
// conta de serviço Imoview vão no body (permite sincronizar antes de salvar).
const v2_actionSyncUsuariosImoview = (agenteId, { email, senha } = {}) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/ai/agentes/${agenteId}/imoview/sync-usuarios`,
        data: { email, senha },
    });
};

export default v2_actionSyncUsuariosImoview;
